(function() {
'use strict';

    angular
        .module('iMatApp')
        .factory('issueTrackEventService', issueTrackEventService);

    issueTrackEventService.$inject = ['mainWorkspace', 'googleTagManagerService'];
    function issueTrackEventService(mainWorkspace, googleTagManagerService) {
        var service = {
            runIssueWatching: runIssueWatching
        };
        
        return service;

        // ---------------------------------------------------------------------------
        function runIssueWatching(scope, issueProvider) {
            scope.$watch(function () {
                return issueProvider();
            }, function (issue) {
                if (issue !== null) {
                    trackIssue(issue);
                }
            });
        }

        // ------------------------- Private ------------------------------------
        function trackIssue(issue) {
            switch (issue.type) {
                case 'DimensionsBelowLimit':
                    trackDimensionsBelowLimitIssue();
                    break;
                default:
                    break;
            }
        }

        function trackDimensionsBelowLimitIssue() {
            var materialName = mainWorkspace.product.material().name;
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Get Validation Error',
                'eventAction': 'Single Upload Page - Too Small Model',
                'eventLabel': 'Selected material: ' + materialName,
                'eventValue': undefined
            });
        }
    }
})();